<template>
  <va-modal
    id="availabilityFormDelete"
    size="small"
    :title="$t('agenda.availability.delete?')"
    :value="showModal"
    :noOutsideDismiss="true"
    :okText="$t('agenda.availability.delete')"
    :okClass="'btn btn-danger btn-micro'"
    @ok="submit"
    :okDisabled="trimmedReason.length < 3"
    :cancelText="'users.cancel' | translate"
    @cancel="cancel">

    <div v-text="$t('agenda.availability.delete_message')"></div>

    <div class="mt-3" v-if="hasRecurrence">
      <fieldset>
        <va-radio-button
          v-for="option in options"
          :key="option.id"
          :option="option.value"
          v-model="form.deleteOption"
          :label="option.label"
        />
      </fieldset>
    </div>

    <!-- Send Email Notification Field -->
    <div class="mt-3" style="margin-bottom: 1rem;">
      <small class="help text-primary my-label">{{$t('agenda.availability.send_notification')}}
        <va-popover
          :message="$t('agenda.availability.remove_tooltip')"
          placement="top"
        >
        <i class="fa fa-info-circle"></i>
        </va-popover>
      </small>
      <br>
      <span class="select is-fullwidth is-small">
        <va-checkbox
        :label="$t('agenda.availability.send_notification')"
        id="checkbox-public"
        :isCircle="true"
        v-model="form.sendNotification"/>
      </span>
    </div>

    <div>
      <label class="form-label">{{$t('agenda.availability.deletion_triggered_by')}}:</label>
      <div class="form-group" style="margin-bottom:2rem;">
        <div class="input-group clearable-filter">
          <multiselect
            v-model="form.deletionTriggeredBy"
            :options="deletionTriggeredOptions"
            track-by="id"
            label="label"
            select-label=""
            deselect-label="×"
            :allow-empty="false"
            :multiple="false"
            :searchable="false"
            :limit="10">
          </multiselect>
        </div>
      </div>
    </div>

    <va-input
      v-model="form.deletedReason"
      :label="$t('references.delete_reason')"
      type="textarea"
      :minRows="3"
      :maxRows="5" />
  </va-modal>
</template>
<script>
import Multiselect from 'vue-multiselect'
import IsFromEvollu from '@/mixins/IsFromEvolluMixin'
export default {
  components: {
    Multiselect
  },
  mixins: [
    IsFromEvollu
  ],
  props: {
    availability: {
      type: Object,
      required: true
    },
    appointments: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data () {
    return {
      showModal: false,
      form: {
        deleteOption: 'current',
        deletionTriggeredBy: 1,
        deletedReason: '',
        sendNotification: true
      },
      options: [
        { id: 1, label: this.$t('agenda.availability.only_current'), value: 'current' },
        { id: 2, label: this.$t('agenda.availability.all_future'), value: 'all_future' },
        { id: 3, label: this.$t('agenda.availability.all'), value: 'all' },
      ],
      deletionTriggeredOptions: [
        { id: 1, label: this.$t('agenda.availability.delete_triggered_entity') },
        { id: 2, label: this.$t('agenda.availability.delete_triggered_evollu') },
        { id: 3, label: this.$t('agenda.availability.delete_triggered_promoters') },
      ],
      deleteOption: 'current',
      deletionTriggeredBy: 1,
      deletedReason: '',
      show: true,
    }
  },
  created () {
    this.form.deletionTriggeredBy = this.deletionTriggeredOptions[0]
  },
  mounted () {
    this.showModal = true
  },
  methods: {
    cancel: function () {
      this.$emit('actionDeleteCanceled')
    },
    submit: function () {
      this.$emit('actionDeletedConfirmed', {
        ...this.form,
        deletedReason: this.trimmedReason,
        deletionTriggeredBy: this.form.deletionTriggeredBy.id
      })
    }
  },
  computed: {
    trimmedReason: function () {
      return this.form.deletedReason.trim()
    },
    hasRecurrence: function () {
      return this.availability.hasRecurrence
    }
  }
}
</script>
